import React, { useState } from "react";
import {
  fetchLoanAgingPie,
  fetchLoanDistByMaturityPie,
  fetchLoanDistByPropTypePie,
  fetchLoanDistByPriorityPie,
  fetchLoanDistPrinBalPie,
} from "../../store/reducers/dashboardSlice/api";
import {
  loanAgingHeader,
  loanDistByMaturityHeader,
  loanDistByPropTypeHeader,
  loanDistByPriorityHeader,
  loanDistByPrinBalHeader,
} from "../../Utils/TableColumnDefs";
import PieChartWithTable from "../PieChartWithTable";
import RevenueYTDPie from "./RevenueYTDPie";
import { LiButton } from "../../Utils/CustomComponent";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setPieSelected } from "../../store/reducers/dashboardSlice";
import { useForm } from "react-hook-form";

const SmallDougnutTable = () => {
  const parentTab = useSelector(
    (state) => state.dashboard.smallDoughnutTableParentTab
  );
  const [activeTab, setActiveTab] = useState(parentTab || 0);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedRole = useSelector((state) => state.account.selectedRole.value);
  const selectedRolLabel = useSelector(
    (state) => state.account.selectedRole.label
  );
  const isDemoAccount = useSelector((state) => state.account.isDemoAccount);
  const userDetails = JSON.parse(localStorage.getItem("accessed_user"));

  const getFeaturesByRoleName = (roleName) => {
    const role = userDetails.role.find((role) => role.role_type === roleName);
    return role
      ? role.features
          .filter((feature) => feature.show_yn === "Y")
          .map((feature) =>
            feature.feature_code.toLowerCase().replace(/\s+/g, "")
          )
      : [];
  };

  const shouldExcludeInvestorTab = selectedRolLabel
    .toLowerCase()
    .includes("roc");
  // ||
  // selectedRolLabel.toLowerCase().includes("broker"); //temporary check - will be removed once the procedure is fixed.

  let features = getFeaturesByRoleName(selectedRole);

  if (shouldExcludeInvestorTab && !isDemoAccount) {
    features = features.filter(
      (feature) => feature !== "loandistributionbyinvestor"
    );
  }

  const { register, watch, setValue } = useForm({
    defaultValues: { date_range: "Year to Date" },
  });

  const handleClick = (data) => {
    let newData;
    if (data.filterKey === "priority") {
      const updatedData = { ...data, value: data?.value?.split("")?.[0] || 1 };
      newData = updatedData;
      dispatch(setPieSelected(updatedData));
    } else {
      newData = data;
      dispatch(setPieSelected(data));
    }
    navigate("/pie-chart-details", { state: newData });
  };

  const tabConfig = features.map((feature) => tabs[feature]).filter(Boolean);
  const formOptions = { register, watch, setValue };
  return (
    <div className="mb-5">
      <div>
        <ul className="nav nav-tabs bg-white border-radius-top--4">
          {tabConfig?.map((data, index) => (
            <LiButton
              key={index}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              label={data?.label}
              value={index}
            />
          ))}
        </ul>
      </div>
      {tabConfig[activeTab]?.renderComponent(
        handleClick,
        formOptions,
        activeTab
      )}
    </div>
  );
};

export default SmallDougnutTable;

let tabs = {
  revenue: {
    label: "Revenue",
    renderComponent: (_, formOptions, index) => (
      <RevenueYTDPie formOptions={formOptions} index={index} />
    ),
  },
  loandistributionbypriority: {
    label: "Loan Distribution by Priority",
    renderComponent: (handleClick, _, index) => (
      <PieChartWithTable
        fetchFunc={fetchLoanDistByPriorityPie}
        fetchKey={"loanDistByPriorityPie"}
        headers={loanDistByPriorityHeader}
        title={"Loan Distribution by Priority"}
        pieLabel={"priority"}
        pieValue={"amount"}
        handleClick={handleClick}
        filterKey={"priority"}
        index={index}
      />
    ),
  },
  loandistributionbymaturity: {
    label: "Loan Distribution by Maturity",
    renderComponent: (handleClick, _, index) => (
      <PieChartWithTable
        fetchFunc={fetchLoanDistByMaturityPie}
        fetchKey={"loanDistByMaturityPie"}
        headers={loanDistByMaturityHeader}
        title={"Loan Distribution by Maturity"}
        pieLabel={"year"}
        pieValue={"amount"}
        handleClick={handleClick}
        filterKey={"year"}
        index={index}
      />
    ),
  },
  loanaging: {
    label: "Loan Aging",
    renderComponent: (handleClick, _, index) => (
      <PieChartWithTable
        fetchFunc={fetchLoanAgingPie}
        fetchKey={"loanAgingPie"}
        headers={loanAgingHeader}
        title={"Loan Aging"}
        pieLabel={"categoryName"}
        pieValue={"amount"}
        handleClick={handleClick}
        filterKey={"days overdue"}
        index={index}
      />
    ),
  },
  loandistributionbyprimarypropertytype: {
    label: "Loan Distribution by Primary Property Type",
    renderComponent: (handleClick, _, index) => (
      <PieChartWithTable
        fetchFunc={fetchLoanDistByPropTypePie}
        fetchKey={"loanDistByPropTypePie"}
        headers={loanDistByPropTypeHeader}
        title={"Loan Distribution by Primary Property Type"}
        pieLabel={"propertyType"}
        pieValue={"amount"}
        handleClick={handleClick}
        filterKey={"property type"}
        index={index}
      />
    ),
  },
  loandistributionbyinvestor: {
    label: "Loan Distribution by Investor",
    renderComponent: (handleClick, _, index) => (
      <PieChartWithTable
        fetchFunc={fetchLoanDistPrinBalPie}
        fetchKey={"loanDistPrinBalPie"}
        headers={loanDistByPrinBalHeader}
        title={"Loan Distribution by Investor"}
        pieLabel={"Lender Account"}
        pieValue={"amount"}
        handleClick={handleClick}
        filterKey={"property type"}
        commonTable={true}
        index={index}
      />
    ),
  },
  // {
  //   label: "Weighted LTV by Primary Property Type",
  //   renderComponent: (handleClick) => (
  //     <PieChartWithTable
  //       fetchFunc={fetchWLTVByPropTypePie}
  //       fetchKey={"wLTVByPropTypePie"}
  //       headers={wLTVByPropTypeHeader}
  //       title={"Weighted LTV by Primary Property Type"}
  //       pieLabel={"propertyType"}
  //       pieValue={"amount"}
  //       handleClick={handleClick}
  //       filterKey={"property type"}
  //     />
  //   ),
  // },
};
